/**
 * @author [Sujan Basnet]
 * @email [basnetsujan95@gmail.com]
 * @create date 2019-04-02 12:39:33
 * @modify date 2019-04-02 12:39:33
 * @desc [description]
*/

import axios from 'axios';
axios.defaults.baseURL = 'api/v1/data/'; // live
// axios.defaults.baseURL = 'http://192.168.1.14:5000/api/v1/data/';

const CANCEL_TOKEN = axios.CancelToken;
let source = null;

const _request = (url, method = "get", data = {}, headers = {}) => {

    if(source !== null) {

        // _cancelOnGoingRequest();

    }
    else {

        source = CANCEL_TOKEN.source();

    }

    switch(method) {

        case "get":

            return axios.get(url, {
                cancelToken: source.token
            });

        case "post":
        
            return axios.post(url, data, headers, {
                    cancelToken: source.token
                } 
            );

        case "put":

            return axios.put(url, data, headers, {
                cancelToken: source.token
            });

        case "patch":

            return axios.patch(url, data, headers, {
                cancelToken: source.token
            });
        
        case "delete":
    
            return axios.delete(url, headers);

        default:    

    }

}


// cancel http requests before getting response
export const _cancelOnGoingRequest = () => {

    source.cancel('request cancelled');

}

export const _isCancellationError = (error) => {

    return axios.isCancel(error);

}

export default _request;